import SocialAssitance from '../view/systemManage/social-assitance/socail-assitance.vue'
import Social from '../view/systemManage/social-assitance/social/social.vue'
import Losing from '../view/systemManage/social-assitance/losing/losing.vue'


const assitance = {
    path: '/assitance',
    component: SocialAssitance,
    redirect: '/assitance/socail',
    children: [
        {
            path: '/assitance/socail',
            name: 'socail',
            component: Social,
            meta: {
                title: '社会求助'
            }
        }, {
            path: '/assitance/losing',
            name: 'losing',
            component: Losing,
            meta: {
                title: '失物招领'
            }
        }
    ]
}

export default assitance
